import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { ObjectHrefModal } from "./ObjectHrefModal";

export function ObjectHrefModalContainer({ scene, onClose, activeObject }) {
  const onSubmit = useCallback(
    ({ href }) => {
      const mediaLoader = activeObject.el.components["media-loader"];
      if (
        mediaLoader &&
        mediaLoader.networkedEl &&
        !NAF.utils.isMine(mediaLoader.networkedEl) &&
        !NAF.utils.takeOwnership(mediaLoader.networkedEl)
      )
        return;
      activeObject.el.setAttribute("media-loader", {
        mediaOptions: Object.assign({}, mediaLoader.data.mediaOptions, {
          href: href
        })
      });
      onClose();
    },
    [scene, activeObject, onClose]
  );
  const mediaLoader = activeObject.el.components["media-loader"];

  const activeObjectHref = mediaLoader && ((mediaLoader.data.mediaOptions && mediaLoader.data.mediaOptions.href) || "");

  return <ObjectHrefModal activeObjectHref={activeObjectHref} onSubmit={onSubmit} onClose={onClose} />;
}

ObjectHrefModalContainer.propTypes = {
  scene: PropTypes.object.isRequired,
  activeObject: PropTypes.object.isRequired,
  onClose: PropTypes.func
};
